<template>
  <div>
    <a-upload-dragger class="upload-dragger" name="file" :multiple="true"
      :beforeUpload="handlerBeforeUpload" :showUploadList="false">
      <a-button class="dg-base-btn">点击选择文件</a-button>
      <p class="ant-upload-hint">
        {{ text }}
      </p>

    </a-upload-dragger>
    <div v-for="(item,index) in fileList" :key="index" class="fileName">
      <span class="name"  @click="nameClick(item)" :title="item.fileName">{{item.fileName}}</span>
      <a-icon class="icon" type="delete" @click="delClick(index)" />
    </div>
    <div v-if="isSlice">正在切片...</div>
    <a-progress :percent="cutRate" size="small" status="active" v-if="isShowPress" />
  </div>

</template>

<script>
const baseUrl = process.env.VUE_APP_BASE_URL
import { getStorage } from '@/utils/index'
import axios from "axios"
import SparkMD5 from "spark-md5"
export default {
  props: {
    instance: Object,
    uploadArray: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      headers: {}, // 请求头
      uploadTypeMap: ['docx', 'xlsx', 'pdf', 'zip', 'rar'], // 限制条件
      url: baseUrl + '/common/partial_upload',
      fileList: [], // 上传结果
      text: '',
      beforeData: {},
      partList: [],
      hash: null,
      total: 0,
      cutRate: 0,
      totalLen: 0,
      isShowPress: false,
      isSlice: false
    }
  },
  watch: {
    instance: {
      handler (nVal) {
        
        if (nVal) {
          this.uploadTypeMap = nVal.fileType
          this.text = nVal.tip
        }
        const defaultV = nVal.defaultValue
        if (defaultV && this.fileList.length === 0) {
          this.fileList = defaultV
        }
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    const token = `${getStorage('token', 0)}`
    this.headers = {
      Authorization: token
    }
    if (this.uploadArray.length > 0) {
      this.uploadTypeMap = this.uploadArray
      // this.text = '只能上传.pdf格式文件不超过2M'
    }
    let { tip, fileType } = this.instance
    this.text = tip
    this.uploadTypeMap = fileType
  },
  methods: {
    delClick(index) {
      
      this.fileList.splice(index,1)
      this.$emit('change', this.fileList)
    },
    nameClick() {

    },
    async handlerBeforeUpload (file) {
      const { name, size } = file
      const type = name.split('.').slice(-1)
      let isOkType = false
      this.isSlice = true
      const { limit } = this.instance
      if (limit && this.fileList.length >= limit) {
        this.$apiStatusHandler(99, `附件上传不能超过${limit}个`)
        return Promise.reject()
      }
      let arr = ['mp4', 'mkv', 'avi']
      let fileType = 2
      if (arr.some(ele => ele === type[0])) {
        fileType = 1
      }
      
      let buffer = await this.fileParse(file, "buffer")
      let spark = new SparkMD5.ArrayBuffer()

      let hash
      spark.append(buffer)
      hash = spark.end()
      let partList = []
      let chunkSize = 2097152
      let cur = 0
      let i = 0
      
      while (cur < size) {
        let item = {
          file: file.slice(cur, cur + chunkSize),
          fileName: name,
          fileMd5: hash,
          chunk: i,
          chunks: Math.ceil(file.size / chunkSize),
          chunkSize: chunkSize,
          fileSize: chunkSize,
          fileType,
          isPublic: 1,
          suffix: type[0]
        };
        cur += chunkSize;
        i += 1
        
        partList.push(item)
      }
      if(cur >= size) {
        
        
        let item = {
          file: file,
          fileName: name,
          fileMd5: hash,
          chunk: 1,
          chunks: 1,
          chunkSize: file.size,
          fileSize: file.size,
          fileType,
          isPublic: 1,
          suffix: type[0]
        };
        partList.push(item)
        
      }
      this.isSlice = false
      this.partList = partList;
      this.hash = hash;
      
      this.totalLen = this.partList.length
      this.sendRequest()
      for (let i = 0; i < this.uploadTypeMap.length; i++) {
        const item = this.uploadTypeMap[i]
        if (type.indexOf(item) !== -1) {
          isOkType = true
          return
        }
      }
      if (!isOkType) {
        this.$apiStatusHandler(99, '上传的附件类型不符合要求')
        return Promise.reject()
      }
    },
    async sendRequest () {
      this.isShowPress = true
      
      // 根据100个切片创造100个请求（集合）
      let requestList = [];
      let data = {}
      
      this.partList.forEach((item, index) => {
        // 每一个函数都是发送一个切片的请求
        let fn = () => {
          let formData = new FormData();
          formData.append("file", item.file);
          formData.append("md5FileVO", JSON.stringify({
            fileName: item.fileName,
            fileMd5: item.fileMd5,
            chunk: index,
            chunks: item.chunks,
            chunkSize: item.chunkSize,
            fileSize: item.fileSize,
            fileType: item.fileType,
            isPublic: item.isPublic,
            suffix: item.suffix
          }));
          
          return axios.post(this.url, formData, {
            headers: { "Content-Type": "multipart/form-data", ...this.headers },
          })
            .then((result) => {
              result = result.data;
              
              if (result.code == 200) {
                this.total += 1;
                this.cutRate = Math.floor((this.total / this.totalLen) * 100)
                
                data = result.data[0]
                // 传完的切片我们把它移除掉
                this.partList.splice(index, 1);
              }
            });
        };
        requestList.push(fn);
      });
      
      // 传递：并行(ajax.abort())/串行(基于标志控制不发送)
      let i = 0;
      let send = async () => {
        if (i >= requestList.length) {
          this.isShowPress = false
          this.total = 0
          this.totalLen = 0
          this.cutRate = 0
          
          this.fileList.push(data)
          
          this.$emit('change', this.fileList)
          
          return;
        }
        await requestList[i]();
        i++;
        send();
      };
      send();
    },
    fileParse (file, type = "base64") {
      return new Promise(resolve => {
        let fileRead = new FileReader();
        if (type === "base64") {
          fileRead.readAsDataURL(file);
        } else if (type === "buffer") {
          fileRead.readAsArrayBuffer(file);
        }
        fileRead.onload = (ev) => {
          resolve(ev.target.result);
        };
      });
    }
  }
}
</script>
